import React from 'react';
import { Link } from 'react-router-dom';
import About1 from '../../images/Electrical-Lighting-Solutions2.jpg';
import { Helmet } from 'react-helmet';

const Electricallighting = (props) => {

      const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    
    return (

         <>
      <Helmet>
        <title>Electrical & Lighting Solutions</title>
        <meta name="description" content="Safe, Efficient & Elegant Electrical Installations" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">

                    <div className="col-lg-6 col-12">
                        <div className="about-right">
                            <div className="text">
                                <span>About</span>
                                <h1>Electrical & Lighting Solutions</h1>
                                <h6>Safe, Efficient & Elegant Electrical Installations</h6>
                                <p>
                               Our certified electrical team provides complete wiring, lighting,
                                and fitting services as part of your interiors or as standalone solutions.
                                </p>
                                <h4>Services include :</h4>
                                <ul>
                                    <li>Concealed wiring & circuit planning</li>
                                    <li>Designer light fitting and installation</li>
                                    <li>False ceiling lighting (LEDs, spotlights)</li>
                                    <li>Fan, geyser, and appliance connections</li>
                                    <li>Safety panel and MCB work</li>
                                    <p>Every detail matters – trust our team for flawless, long-lasting results.</p>
                                </ul>
                              <a href='tel:9663222146' className='theme-btn'>Call Us: +91 96632 22146</a>
                            </div>
                        </div>
                    </div>
                    
                <div className="col-lg-6 col-12">
                        <div className="about-left">
                            <img src={About1} alt="" />
                            
                        </div>
                    </div>
                    
                
                
                </div>
            </div>
        </section>
    </>
        
    )
}

export default Electricallighting ;